import styled from 'styled-components';
import { Fieldset } from '../../../baseComponents';
import { TypographyStyles, colours, media, spacing } from '../../../stylings';

export const LanguageSelectionContainer = styled.div`
  ${TypographyStyles.Body.Tiny.Regular}
  display: flex;
  flex-direction: column;
  gap: ${spacing.XS};

  @media ${media.greaterThan('lg')} {
    gap: ${spacing.XXXS};
  }

  > p {
    margin: 0;
    padding: 0;
  }
`;

export const LanguageSelectionList = styled(Fieldset)`
  border: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${spacing.XS};
  margin: 0 0 ${spacing.XS};
  padding: 0;
`;

export const LanguageSelectionWrapper = styled.div`
  align-items: center;
  display: flex;

  > label {
    ${TypographyStyles.Body.Tiny.Regular}
    cursor: pointer;
    overflow-wrap: anywhere;
    padding: 0 0 0 10px;
  }

  > input[type='radio'] {
    cursor: pointer;
    flex-shrink: 0;
    height: ${spacing.S};
    margin: 0;
    width: ${spacing.S};

    &:focus {
      outline-color: ${colours.OUTLINE_BORDER};
      outline-width: 2px;
    }
  }

  > input[type='radio']:checked {
    accent-color: ${colours.DARK_BLUE};
  }
`;
